import { EventEmitter, Directive, Inject, PLATFORM_ID, Optional, ElementRef, Renderer2, Input, InjectionToken, NgModule, Injectable, ɵɵdefineInjectable, ɵɵinject } from '@angular/core';
import { isPlatformBrowser, CommonModule, DOCUMENT } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { debounceTime, throttle, tap, distinctUntilChanged } from 'rxjs/operators';
import { of, fromEvent, combineLatest, interval, timer, BehaviorSubject } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/wow-setting.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class WowSetting {
}
if (false) {
    /**
     * 是否開啟特效
     * @type {?}
     */
    WowSetting.prototype.turnOn;
    /**
     * 運用特效
     * @type {?}
     */
    WowSetting.prototype.animate;
}
/** @enum {number} */
const EnumScrollType = {
    Up: 0,
    Down: 1,
    UpDown: 2,
};
EnumScrollType[EnumScrollType.Up] = 'Up';
EnumScrollType[EnumScrollType.Down] = 'Down';
EnumScrollType[EnumScrollType.UpDown] = 'UpDown';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} renderer
 * @param {?} parentEl
 * @param {?} styleName
 * @param {?} path
 * @param {?=} preload
 * @return {?}
 */
function loadLazyCssFile(renderer, parentEl, styleName, path, preload) {
    if (document.getElementById(styleName)) {
        return;
    }
    /** @type {?} */
    const style = renderer.createElement('link');
    /** @type {?} */
    const noscriptStyle = renderer.createElement('link');
    renderer.setAttribute(style, 'id', `${styleName}`);
    renderer.setAttribute(noscriptStyle, 'id', `noscript_${styleName}`);
    renderer.setAttribute(style, 'href', `${path}`);
    renderer.setAttribute(noscriptStyle, 'href', `${path}`);
    renderer.setAttribute(style, 'onload', `this.rel='stylesheet'`);
    if (preload) {
        renderer.setAttribute(style, 'rel', `preload`);
        renderer.setAttribute(noscriptStyle, 'rel', `stylesheet`);
        renderer.setAttribute(style, 'as', `style`);
    }
    else {
        renderer.setAttribute(style, 'rel', `stylesheet`);
    }
    /** @type {?} */
    const body = parentEl.closest('body');
    renderer.insertBefore(body, style, body.firstElementChild);
    if (preload) {
        /** @type {?} */
        const bodyNoScript = body.querySelectorAll('noscript')[2];
        if (bodyNoScript.childElementCount === 0) {
            renderer.appendChild(bodyNoScript, noscriptStyle);
        }
        else {
            renderer.insertBefore(bodyNoScript, noscriptStyle, bodyNoScript.firstElementChild);
        }
    }
}
/**
 * @param {?} renderer
 * @param {?} scriptName
 * @param {?} path
 * @param {?=} useDefer
 * @return {?}
 */
function loadLazyJsFile(renderer, scriptName, path, useDefer) {
    if (document.getElementById(scriptName)) {
        return;
    }
    /** @type {?} */
    const script = renderer.createElement('script');
    renderer.setAttribute(script, 'id', `${scriptName}`);
    renderer.setAttribute(script, 'type', `text/javascript`);
    renderer.setAttribute(script, 'src', `${path}`);
    renderer.setAttribute(script, 'async', ``);
    if (useDefer) {
        renderer.setAttribute(script, 'defer', ``);
    }
    // 用 document 塞在 server 端部會有作用, 但沒關係這個在 client 端在執行就好
    // 用 parentEl.closest('body').previousSiblingsElement appendChild 也沒用 (但 insertBefore 沒試過)
    renderer.appendChild(document.head, script);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/wow.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TmWowDirective {
    /**
     * @param {?} platformId
     * @param {?} assets
     * @param {?} elRef
     * @param {?} render
     */
    constructor(platformId, assets, elRef, render) {
        this.platformId = platformId;
        this.assets = assets;
        this.elRef = elRef;
        this.render = render;
        /**
         * 是否可以開始使用元件了
         */ 
        // tslint:disable-next-line: member-ordering
        this.canInit = false;
        /**
         * 運用特效
         */ 
        // tslint:disable-next-line: member-ordering
        this._config = {
            turnOn: false,
            animate: 'fadeInUp',
        };
        /**
         * 應用特效時機
         */ 
        // tslint:disable-next-line: member-ordering
        this.applyScroll = EnumScrollType.Down;
        /**
         * 是否重複特效
         */ 
        // tslint:disable-next-line: member-ordering
        this.replay = false;
        /**
         * 意義不明
         */ 
        // tslint:disable-next-line: member-ordering
        this.animateEnd = false;
        this._subcs = [];
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.el = this.elRef.nativeElement;
        this.genCount = TmWowDirective.count++;
        this.render.addClass(this.el, `wow-gen-${this.genCount}`);
    }
    /**
     * 載入插件的方法
     * @param {?} renderer
     * @param {?} parentEl
     * @param {?} assetsConfig
     * @return {?}
     */
    static loadPlugin(renderer, parentEl, assetsConfig) {
        TmWowDirective.isPluginIniting = true;
        assetsConfig.scripts.forEach((/**
         * @param {?} sc
         * @return {?}
         */
        sc => {
            /** @type {?} */
            const sca = sc.split('/');
            /** @type {?} */
            const scName = sca[sca.length - 1];
            loadLazyJsFile(renderer, scName, sc);
        }));
        assetsConfig.styles.forEach((/**
         * @param {?} st
         * @return {?}
         */
        st => {
            /** @type {?} */
            const sta = st.split('/');
            /** @type {?} */
            const stName = sta[sta.length - 1];
            loadLazyCssFile(renderer, parentEl, stName, st);
        }));
        checkPluginCanUse((/**
         * @return {?}
         */
        () => {
            TmWowDirective.isPluginInit = true;
            TmWowDirective.isPluginIniting = false;
            TmWowDirective.pulginInit.emit();
            TmWowDirective.pulginInit.complete();
        }));
    }
    /**
     * 運用特效
     * @param {?} config
     * @return {?}
     */
    set config(config) {
        if (config) {
            this._config = config;
        }
    }
    /**
     * @return {?}
     */
    get config() { return this._config; }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            if (!TmWowDirective.isPluginInit && !TmWowDirective.isPluginIniting) {
                if (isPluginLoaded()) {
                    TmWowDirective.isPluginInit = true;
                }
                else {
                    TmWowDirective.loadPlugin(this.render, this.elRef.nativeElement, this.assets || wowAssetsDefaultConfig);
                }
            }
            if (!TmWowDirective.isPluginInit) {
                TmWowDirective.pulginInit.subscribe((/**
                 * @return {?}
                 */
                () => {
                    this.init();
                    this.canInit = true;
                }));
            }
            else {
                this.init();
                this.canInit = true;
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.scrollSubc) {
            this.scrollSubc.unsubscribe();
        }
        while (this._subcs.length) {
            this._subcs.pop().unsubscribe();
        }
    }
    /**
     * @return {?}
     */
    init() {
        /*
         * 在viewInit後開始抓取元素
         * 判斷如果自己本身為IMG
         * 或子層元素為IMG
         * 如果自身為IMG，監聽自己的load事件，完成後開始計算宿主元素高度
         * 如果子層元素有IMG，監聽它的load事件，完成後開始計算宿主元素高度
         * 如都沒有，直接開始計算宿主元素高度
         * 觸發wow動畫
        */
        if (this.config.turnOn) {
            // 將套件新增原型方法addBox，來重複特效用
            WOW.prototype['addBox'] = (/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                this.boxes.push(e);
            });
            /** @type {?} */
            const isImg = this.el.tagName === 'IMG';
            /** @type {?} */
            const childImgs = this.el.querySelectorAll('img');
            if (childImgs && childImgs.length) {
                /** @type {?} */
                const cImgLoadStatu$s = [];
                for (let i = 0; i < childImgs.length; i++) {
                    /** @type {?} */
                    const cImg = childImgs[i];
                    if (cImg.complete) {
                        cImgLoadStatu$s[i] = of(true);
                    }
                    else {
                        cImgLoadStatu$s[i] = fromEvent(cImg, 'load');
                    }
                }
                /** @type {?} */
                const subc = combineLatest(cImgLoadStatu$s).subscribe((/**
                 * @param {?} v
                 * @return {?}
                 */
                v => {
                    this.initWow();
                }));
                this._subcs.push(subc);
            }
            else if (isImg) {
                if (((/** @type {?} */ (this.el))).complete && ((/** @type {?} */ (this.el))).naturalHeight) {
                    this.initWow();
                }
                else {
                    this.render.listen(this.el, 'load', (/**
                     * @param {?} evt
                     * @return {?}
                     */
                    (evt) => {
                        this.initWow();
                    }));
                }
            }
            else {
                this.initWow();
            }
        }
    }
    /**
     * 程式初始化流程
     * @private
     * @return {?}
     */
    initWow() {
        /*
            * 以宿主元素傳進的屬性來構成物件
            * 以物件的鍵值跑迴圈
            * 如果此鍵有值
            * 將宿主元素加上屬性 data-wow-${attrKey}=value
            */
        /** @type {?} */
        const attrArray = {
            duration: this.duration ? this.duration + 's' : null,
            offset: this.offset,
            delay: this.delay ? this.delay + 's' : null,
            iteration: this.iteration,
        };
        Object.keys(attrArray).forEach((/**
         * @param {?} attrKey
         * @return {?}
         */
        (attrKey) => {
            if (attrArray[attrKey]) {
                this.el.setAttribute(`data-wow-${attrKey}`, attrArray[attrKey]);
            }
        }));
        // 將元素加上class wow、傳入的效果名稱
        this.el.classList.add('wow', this.config.animate);
        if (this.replay) {
            this.scrollSubc = fromEvent(window, 'scroll').pipe(debounceTime(50), throttle((/**
             * @param {?} ev
             * @return {?}
             */
            ev => interval(50)))).subscribe((/**
             * @return {?}
             */
            () => this.scrollDetect(this.el)));
        }
        // this.wowService.registSlide(this, this.render);
        if (this.isBrowser) {
            // Initializes the library
            this.instance = new WOW({
                boxClass: `wow-gen-${this.genCount}`,
            });
            this.instance.init();
        }
    }
    /**
     * 計算宿主元素是否於可視範圍內
     * @private
     * @param {?} element
     * @return {?}
     */
    scrollDetect(element) {
        /** @type {?} */
        const contentHeight = this.el.getBoundingClientRect().height;
        if (!this.animateEnd) {
            // 取得元件距離視窗的位置
            /** @type {?} */
            const objPos = element.getBoundingClientRect().top;
            // 如果 objpos 物件對於視窗上方的距離
            /** @type {?} */
            const invisible = objPos <= contentHeight * -1;
            // 判斷如果元件超出可視範圍上緣
            /** @type {?} */
            const visible = window
                .getComputedStyle(element)
                .getPropertyValue('visibility');
            // 取得元素上的visibility屬性(由wowjs加上)
            if (invisible && visible !== 'hidden' && this.applyScroll == EnumScrollType.Up) {
                /* 如果元素超出畫面上方
                  * 且還未撥放動畫
                  * 且設定不是下滾動觸發(上滾動或上下滾動)
                  * 初始化該元素的animate狀態
                  */
                this.resetAnimateCss(element);
            }
            if (objPos >= window.innerHeight && visible === 'visible' && this.applyScroll == EnumScrollType.Down) {
                /* 如果元素超出畫面下方
                  * 且動畫已經撥放完
                  * 且設定不是上滾動觸發(上滾動或上下滾動)
                  *  初始化該元素的animate狀態
                  */
                this.resetAnimateCss(element);
            }
        }
    }
    /**
     * 重新初始化wow
     * @private
     * @param {?} element
     * @return {?}
     */
    resetAnimateCss(element) {
        // 元素清空wowjs加上的class或style
        element.classList.remove('animated');
        element.style.cssText = 'visibility: hidden; animation-name: none';
        // 呼叫addBox方法初始化新的動畫
        this.instance['addBox'](element);
        this.animateEnd = false;
    }
}
TmWowDirective.count = 0;
/**
 * wow 插件初始化完成後觸發
 */
TmWowDirective.pulginInit = new EventEmitter();
/**
 * 全域的 wow 插件初始化完成
 */
TmWowDirective.isPluginInit = false;
/**
 * 全域的 wow 插件在正初始化中
 */
TmWowDirective.isPluginIniting = false;
TmWowDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmWow]',
                exportAs: 'tmWow',
            },] }
];
/** @nocollapse */
TmWowDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [WOW_ASSETS,] }] },
    { type: ElementRef },
    { type: Renderer2 }
];
TmWowDirective.propDecorators = {
    config: [{ type: Input, args: ['tmWow',] }],
    applyScroll: [{ type: Input }],
    replay: [{ type: Input }],
    duration: [{ type: Input }],
    offset: [{ type: Input }],
    delay: [{ type: Input }],
    iteration: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    TmWowDirective.count;
    /**
     * wow 插件初始化完成後觸發
     * @type {?}
     */
    TmWowDirective.pulginInit;
    /**
     * 全域的 wow 插件初始化完成
     * @type {?}
     */
    TmWowDirective.isPluginInit;
    /**
     * 全域的 wow 插件在正初始化中
     * @type {?}
     */
    TmWowDirective.isPluginIniting;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    TmWowDirective.prototype.isBrowser;
    /**
     * 是否可以開始使用元件了
     * @type {?}
     */
    TmWowDirective.prototype.canInit;
    /**
     * 取得綁定的元素DOM
     * @type {?}
     */
    TmWowDirective.prototype.el;
    /**
     * 運用特效
     * @type {?}
     * @private
     */
    TmWowDirective.prototype._config;
    /**
     * 應用特效時機
     * @type {?}
     */
    TmWowDirective.prototype.applyScroll;
    /**
     * 是否重複特效
     * @type {?}
     */
    TmWowDirective.prototype.replay;
    /**
     * Change the animation duration
     * @type {?}
     */
    TmWowDirective.prototype.duration;
    /**
     * Distance to start the animation (related to the browser bottom)
     * @type {?}
     */
    TmWowDirective.prototype.offset;
    /**
     * Delay before the animation starts
     * @type {?}
     */
    TmWowDirective.prototype.delay;
    /**
     * Number of times the animation is repeated
     * @type {?}
     */
    TmWowDirective.prototype.iteration;
    /**
     * 意義不明
     * @type {?}
     */
    TmWowDirective.prototype.animateEnd;
    /**
     * @type {?}
     * @private
     */
    TmWowDirective.prototype.scrollSubc;
    /**
     * @type {?}
     * @private
     */
    TmWowDirective.prototype._subcs;
    /**
     * @type {?}
     * @private
     */
    TmWowDirective.prototype.instance;
    /**
     * @type {?}
     * @private
     */
    TmWowDirective.prototype.genCount;
    /**
     * @type {?}
     * @private
     */
    TmWowDirective.prototype.platformId;
    /**
     * @type {?}
     * @private
     */
    TmWowDirective.prototype.assets;
    /**
     * @type {?}
     * @private
     */
    TmWowDirective.prototype.elRef;
    /**
     * @type {?}
     * @private
     */
    TmWowDirective.prototype.render;
}
/**
 * @return {?}
 */
function isPluginLoaded() {
    return window['WOW'];
}
/** @type {?} */
const checkPluginCanUse = (/**
 * @param {?} cb
 * @return {?}
 */
(cb) => {
    /** @type {?} */
    const cpTmSubc = timer(0, 150).subscribe((/**
     * @param {?} t
     * @return {?}
     */
    t => {
        if (isPluginLoaded()) {
            cpTmSubc.unsubscribe();
            cb();
        }
    }));
});
const ɵ0 = checkPluginCanUse;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/wow.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const WOW_ASSETS = new InjectionToken('WOW_ASSETS');
/** @type {?} */
const wowAssetsDefaultConfig = {
    scripts: ['/assets/wow/wow.min.js'],
    styles: ['/assets/animate/animate.min.css']
};
/**
 * [WOW](https://wowjs.uk/docs.html) 包裝模組，
 * 在引用套件的模組提供 WOW_ASSETS 這個依賴項目
 * ```typescript
 * {provide: WOW_ASSETS, useValue: {
 *   scripts: ['/assets/wow/wow.min.js'],
 *   styles:  ['/assets/animate/animate.min.css']
 * }}
 * ```
 */
class TmWowModule {
}
TmWowModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    TmWowDirective,
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                ],
                exports: [
                    TmWowDirective,
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/wow-config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Configuration for the NgwWowService service.
 */
class NgwWowConfig {
    constructor() {
        /**
         * Class name that reveals the hidden box when user scrolls.
         */
        this.boxClass = 'wow';
        /**
         * Class name that triggers the CSS animations ('animated' by default for the animate.css library)
         */
        this.animateClass = 'animated';
        /**
         * Define the distance between the bottom of browser viewport and the top of hidden box.
         * When the user scrolls and reach this distance the hidden box is revealed.
         */
        this.offset = 0;
        /**
         * Turn on/off WOW.js on mobile devices.
         */
        this.mobile = true;
        /**
         * Consatantly check for new WOW elements on the page.
         */
        this.live = true;
    }
}
if (false) {
    /**
     * Class name that reveals the hidden box when user scrolls.
     * @type {?}
     */
    NgwWowConfig.prototype.boxClass;
    /**
     * Class name that triggers the CSS animations ('animated' by default for the animate.css library)
     * @type {?}
     */
    NgwWowConfig.prototype.animateClass;
    /**
     * Define the distance between the bottom of browser viewport and the top of hidden box.
     * When the user scrolls and reach this distance the hidden box is revealed.
     * @type {?}
     */
    NgwWowConfig.prototype.offset;
    /**
     * Turn on/off WOW.js on mobile devices.
     * @type {?}
     */
    NgwWowConfig.prototype.mobile;
    /**
     * Consatantly check for new WOW elements on the page.
     * @type {?}
     */
    NgwWowConfig.prototype.live;
    /**
     * Callback called when the given box element is shown.
     * @type {?}
     */
    NgwWowConfig.prototype.callback;
    /** @type {?} */
    NgwWowConfig.prototype.scrollContainer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/wow.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @deprecated
 */
class WowService {
    /**
     * @param {?} platformId
     * @param {?} document
     */
    constructor(platformId, document) {
        this.platformId = platformId;
        this.document = document;
        /**
         * 放所有 slide 的陣列
         */
        this.items$ = new BehaviorSubject([]);
        /**
         * 畫面是否已經渲染完成
         */
        this.isRendered = false;
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * 將一個 slide 註冊到 items 管理器
     * @param {?} slide 一個 slide 的指令索引
     * @param {?} renderer 渲染器，需要從 slide 帶進來
     * @return {?}
     */
    registSlide(slide, renderer) {
        if (!this.renderer) {
            // 第一個註冊進來的 slide 需要做些初始化動作
            this.renderer = renderer;
            this.startListentSlidesChange();
        }
        /** @type {?} */
        const items = this.items$.value;
        /** @type {?} */
        const newItems = items.slice();
        newItems.push(slide);
        this.items$.next(newItems);
    }
    /**
     * 開始監聽 slide 註冊變化，直到 slide 穩定後就渲染 items
     * @private
     * @return {?}
     */
    startListentSlidesChange() {
        if (this.itemChangeSubc) {
            return;
        }
        this.itemChangeSubc = this.items$.pipe(tap((/**
         * @param {?} items
         * @return {?}
         */
        items => console.log('items', items))), debounceTime(100), distinctUntilChanged()).subscribe((/**
         * @param {?} items
         * @return {?}
         */
        items => {
            if (items && items.length) {
                this.rendSlides(items);
            }
            else {
                this.destroySlides();
            }
            // this.stopListentSlidesChange();
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => {
            console.error(error);
        }));
    }
    /**
     * 結束監聽 slide 註冊變化
     * @private
     * @return {?}
     */
    stopListentSlidesChange() {
        if (this.itemChangeSubc) {
            this.itemChangeSubc.unsubscribe();
            delete this.itemChangeSubc;
        }
    }
    /**
     * 渲染 items
     * @private
     * @param {?} items
     * @return {?}
     */
    rendSlides(items) {
        if (this.isRendered) {
            this.destroySlides();
        }
        this.init();
        this.isRendered = true;
    }
    /**
     * items 渲染的銷毀，只會還原畫面但不會對整個 items 管理器做重置，用來在 slide 數量改變時重新更新 slide
     * @private
     * @return {?}
     */
    destroySlides() {
        if (!this.isRendered) {
            return;
        }
        this.isRendered = false;
    }
    /**
     * @param {?=} config
     * @return {?}
     */
    init(config) {
        if (this.isBrowser) {
            // Initializes the library
            this.instance = new WOW(config);
            this.instance.init();
        }
    }
}
WowService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
WowService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
/** @nocollapse */ WowService.ngInjectableDef = ɵɵdefineInjectable({ factory: function WowService_Factory() { return new WowService(ɵɵinject(PLATFORM_ID), ɵɵinject(DOCUMENT)); }, token: WowService, providedIn: "root" });
if (false) {
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    WowService.prototype.isBrowser;
    /**
     * 放所有 slide 的陣列
     * @type {?}
     * @private
     */
    WowService.prototype.items$;
    /**
     * @type {?}
     * @private
     */
    WowService.prototype.itemChangeSubc;
    /**
     * 畫面是否已經渲染完成
     * @type {?}
     * @private
     */
    WowService.prototype.isRendered;
    /**
     * dom 渲染器，筆須由指令帶入
     * @type {?}
     * @private
     */
    WowService.prototype.renderer;
    /** @type {?} */
    WowService.prototype.instance;
    /**
     * @type {?}
     * @private
     */
    WowService.prototype.platformId;
    /**
     * @type {?}
     * @protected
     */
    WowService.prototype.document;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: techmore-wow.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { EnumScrollType, NgwWowConfig, TmWowDirective, TmWowModule, WOW_ASSETS, WowService, WowSetting, wowAssetsDefaultConfig };
//# sourceMappingURL=techmore-wow.js.map
